import { readonlyIsCopied, readonlyIsClipboardSupported } from './state'
import { copy } from './methods/copy'
import { copyAllContent, copyText, copyHashtags, copyLink } from './methods/copy-content'

/**
 * Clipboard functionality composable
 * @returns {Object} Clipboard state and methods
 */
export function useClipboard() {
  return {
    // State
    isCopied: readonlyIsCopied,
    isClipboardSupported: readonlyIsClipboardSupported,
    
    // Methods
    copy,
    copyAllContent,
    copyText,
    copyHashtags,
    copyLink,
  }
}
